import { DealProps } from '../types/deal';

/**
 * Generate SEO-friendly deal URL with slug
 * @param deal Deal object containing _id and optional slug
 * @returns URL string in format /deals/id/slug or /deals/id if no slug
 */
export const generateDealUrl = (deal: DealProps): string => {
  if (deal.slug) {
    return `/deals/${deal._id}/${deal.slug}`;
  }
  // Fallback for deals without slugs (during migration period)
  return `/deals/${deal._id}`;
};

/**
 * Generate absolute SEO-friendly deal URL for sharing
 * @param deal Deal object containing _id and optional slug
 * @param baseUrl Base URL of the site (defaults to window.location.origin)
 * @returns Full URL string
 */
export const generateDealShareUrl = (deal: DealProps, baseUrl?: string): string => {
  const base = baseUrl || (typeof window !== 'undefined' ? window.location.origin : '');
  return base + generateDealUrl(deal);
};
